import React from 'react'
import Employee from '../Components/Employee/Employee'
import EmployeeList from '../Components/Employee/EmployeeList'

const EmployeeListPage = () => {
  return (
    <div style={{padding:"8px 0px"}} className='NewFormBackColor'>
      <Employee/>
    </div>
  )
}

export default EmployeeListPage
